<template>
    <div class="position-sticky task-title container-fluid py-2">
        <div class="d-flex justify-content-between align-items-center">
            <h4 class="text-dark font-weight-bolder mb-0">
                事項一覽
            </h4>
            <div class="d-flex align-items-center">
                <b-form-input class="rounded-pill border-0 shadow-sm mr-3"
                              type="search"
                              size="sm"
                              placeholder="🔎 請輸入關鍵字"
                              v-model="keywords"
                              v-on:input="handleInput">
                </b-form-input>
                <div class="btn-group">
                    <router-link class="btn btn-sm btn-light text-nowrap border rounded-pill shadow-sm px-3"
                                 active-class="active"
                                 to="/tasks/kanban">
                        <font-awesome-icon v-bind:icon="['fad', 'game-board']"></font-awesome-icon> 看板
                    </router-link>
                    <router-link class="btn btn-sm btn-light text-nowrap border rounded-pill shadow-sm px-3"
                                 active-class="active"
                                 to="/tasks/list">
                        <font-awesome-icon v-bind:icon="['fad', 'clipboard-list-check']"></font-awesome-icon> 清單
                    </router-link>
                </div>
            </div>
        </div>

        <modal-search-tasks v-bind:keywords.sync="keywords"
                            v-model="isModalSearchTasksOpen">
        </modal-search-tasks>
    </div>
</template>

<script>
import { BFormInput, } from "bootstrap-vue";
import ModalSearchTasks from "./TaskTitle/ModalSearchTasks";

export default {
    name: "TaskTitle",
    components: {
        ModalSearchTasks,
        BFormInput,
    },
    data () {
        return {
            isModalSearchTasksOpen: false,
            keywords: "",
        };
    },
    computed: {

    },
    methods: {
        handleInput (keywords) {
            if (
                keywords &&
                keywords.length > 1 &&
                this.isModalSearchTasksOpen === false
            ) {
                this.isModalSearchTasksOpen = true;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.task-title {
    top: 0;
    z-index: 1;

    background-color: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(2.5px);
}

.btn-group {
    .rounded-pill {
        &:first-of-type {
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }

        &:last-of-type {
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
        }
    }
}
</style>
